module.exports = __webpack_public_path__ + "97uahxiqZRoncBaCEI3aWxJtnKITppOI_IvcXXDNrsc.c1504e628d22111a6b7d.woff2";


//////////////////
// WEBPACK FOOTER
// D:/OficinaVirtual/FrontEndFinamco/EFactoringManager/src/assets/fonts/roboto/97uahxiqZRoncBaCEI3aWxJtnKITppOI_IvcXXDNrsc.woff2
// module id = ../../../../../src/assets/fonts/roboto/97uahxiqZRoncBaCEI3aWxJtnKITppOI_IvcXXDNrsc.woff2
// module chunks = styles